import { RELATED_LINKS } from '../../lib/relatedLinks';

/** Site-wide footer pinned beneath the studio. Each entry reads as
 *  "[footerPrefix] LINK → — blurb"; entries without a prefix/blurb
 *  collapse to just their label. Bulleted separators between items
 *  are rendered with CSS so the markup stays a flat span list. */
export function LinksV1_Footer() {
  return (
    <footer className="links-v1-footer" aria-label="Site footer">
      <span className="links-v1-author">Made by Yang Yu</span>
      {RELATED_LINKS.map((link) => (
        <span key={link.id} className="links-v1-item">
          {link.footerPrefix && (
            <span className="links-v1-prefix">{link.footerPrefix} </span>
          )}
          {link.comingSoon ? (
            <span className="links-v1-soon">{link.label} (soon)</span>
          ) : (
            <a
              className="links-v1-link"
              href={link.href}
              target="_blank"
              // Use only "noopener" (not "noopener noreferrer") so the
              // destination site CAN see the Referer header — this lets
              // pawsympathy.com (and other owned sites we add to
              // RELATED_LINKS) attribute traffic that came from here.
              // If a future entry is to a site we don't own/trust,
              // override per-link to also include noreferrer.
              rel="noopener"
            >
              {link.label} <span aria-hidden>→</span>
            </a>
          )}
          {link.blurb && (
            <span className="links-v1-blurb"> — {link.blurb}</span>
          )}
        </span>
      ))}
    </footer>
  );
}
